import { Component,Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dms-queueexception',
  templateUrl: './dms-queueexception.component.html'
})
export class DmsQueueexceptionComponent implements OnInit {

  @Input() dMSQueueLogList: any;
  @Input() modelHeader: any;
  @Input() integrationWithDMS:any;
  logList: any;

 constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {

    this.logList = this.dMSQueueLogList;
  }

}
